module.exports = __webpack_public_path__ + "static/media/cluster-questions-2.83292490.jpg";